import { useLocalizedStringFormatter } from "react-aria";
import locales from "./locales.js";
const useI18n = () => {
  return useLocalizedStringFormatter(locales, "@cvpartner/design-system");
};
export default useI18n;
//# sourceMappingURL=useI18n.js.map